import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import loanService, { LoanDto } from "../../services/loanService";
import { useEffect, useState } from "react";
import Frame from "../../components/controls/Frame/Frame";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FormCommand from "../../components/controls/FormCommand";
import Label from "../../components/controls/Label";
import FormModal from "../../components/controls/FormModal";
import CheckBox from "../../components/controls/Checkbox/CheckBox";
import {
  MdClearAll,
  MdDelete,
  MdEdit,
  MdFileOpen,
  MdFilePresent,
  MdPayment,
  MdReport,
  MdSchedule,
  MdSend,
} from "react-icons/md";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MenuItem } from "../../models/menu";

export function getLoanContextMenu(): MenuItem<LoanDto>[] {
  return [
    {
      name: "Edit",
      onClick: (d) => {
        alert(d.loanAccountId);
      },
      icon: <MdEdit />,
    },
    {
      name: "Delete",
      onClick: (d) => {
        alert(d.loanAccountId);
      },
      icon: <MdDelete />,
    },
    {
      name: "Post",
      onClick: (d) => {
        alert("post ft");
      },
      icon: <MdSend />,
    },
    {
      name: "View repayments",
      onClick: (d) => {
        alert("View repayments");
      },
    },
    {
      name: "View schedule",
      onClick: (d) => {
        var repaymentSchedules = loanService.getRepaymentSchedule(d.id);
        // display repayment schedules
        alert("view schedule");
      },
      icon: <MdSchedule />,
    },
    {
      name: "Post Manual Repayment",
      onClick: (d) => {
        alert("Manual repayment");
      },
      icon: <MdPayment />,
    },
    {
      name: "Clear Loan",
      onClick: (d) => {
        alert("Clear Loan");
      },
      icon: <MdClearAll />,
    },
  ];
}

export interface LoanListingPageProps {}

export const LoanListingPage = (props: LoanListingPageProps) => {
  const [loan, setLoan] = useState<LoanDto>();
  const [loans, setLoans] = useState<LoanDto[]>([]);

  const getLoans = async () => {
    var res = await loanService.getLoans({
      pageIndex: 1,
      recordCount: 10,
      loanAccountName: "",
    });

    setLoans([...res.data!]);
  };

  useEffect(() => {
    getLoans();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h3>Loans & Credits</h3>
            <GridView
              showAddButton={true}
              showSearchBar={true}
              keys={["name"]}
              name={"lstTransactions"}
              rowsPerPage={50}
              onAddRecord={() => setLoan({})}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Amount</th>
                    <th>Loan Type</th>
                    <th>Amount</th>
                    <th>Balance</th>
                    <th>Rate</th>
                    <th>Reason</th>
                    <th>Date Range</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {loans.map((d) => (
                  <tr>
                    <td>{d.loanAccountName}</td>
                    <td>{d.amount}</td>
                    <td>{d.loanType}</td>
                    <td>{d.amount}</td>
                    <td>{d.rate}</td>
                    <td>{d.reason}</td>
                    <td>
                      {d.startDate?.toLocaleDateString() +
                        " - " +
                        d.endDate?.toLocaleDateString()}
                    </td>
                    <td>
                      <ContextMenu item={d} menu={getLoanContextMenu()} />
                    </td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {loan && (
        <FormModal title="Loan Entry" onClose={() => setLoan(undefined)}>
          <LoanForm></LoanForm>
        </FormModal>
      )}
    </>
  );
};

export function LoanForm() {
  return (
    <div className="row">
      <div className="col">
        <div className="row">
          <div className="col">
            <FindAccount text="Loan Account" id="loanAccount" />
          </div>
          <div className="col">
            <FindAccount text="Repayment Account" id="repaymentAccount" />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="startDate" className="control-label">
                Start Date
              </label>
              <input
                type="date"
                name="startDate"
                id="startDate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="duration" className="control-label">
                Duration <small>(In days)</small>
              </label>
              <input
                type="number"
                name="duration"
                id="duration"
                className="form-control form-control-sm"
                min={1}
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="endDate" className="control-label">
                End Date
              </label>
              <input
                type="date"
                name="endDate"
                id="endDate"
                className="form-control form-control-sm"
                readOnly
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-4">
            <div className="form-group">
              <label htmlFor="loanSector" className="control-label">
                Loan Sector
              </label>
              <select
                name="loanSector"
                id="loanSector"
                className="form-control form-control-sm"
              >
                <option value="">Select Sector</option>
              </select>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="repaymentStartDate" className="control-label">
                Repayment Start Date
              </label>
              <input
                type="date"
                name="repaymentStartDate"
                id="repaymentStartDate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="rate" className="control-label">
                Rate
              </label>
              <input
                type="number"
                name="rate"
                id="rate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="rateType" className="control-label">
                Rate Type
              </label>
              <select
                name="rateType"
                id="rateType"
                className="form-control form-control-sm"
              >
                <option>Rate type</option>
                <option value="reducingBalance">Reducing Balance</option>
                <option value="flatRate">Flat Rate</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <CheckBox
              id="enablePartRepayment"
              text="Enable part repayment"
              type="switchbox"
            />
            <CheckBox
              id="chargeInterestUpfront"
              text="Charge Interest Upfront"
              type="switchbox"
            />
            <CheckBox
              id="excludeWeekEndsFromSchedule"
              text="Exclude Weekends"
              type="switchbox"
            />
            <CheckBox
              id="excludePublicHoliday"
              text="Exclude Holidays"
              type="switchbox"
            />
          </div>

          <div className="col">
            <div className="form-group">
              <label htmlFor="repaymentFrequency" className="control-label">
                Repayment Frequency
              </label>
              <select
                name="repaymentFrequency"
                id="repaymentFrequency"
                className="form-control form-control-sm"
              >
                <option>Repayment Frequency</option>
              </select>
            </div>
            <div className="form-group">
              <Label text="Credit Officer" name="creditOfficer" />
              <select
                name="creditOfficer"
                id="creditOfficer"
                title="Select Credit Officer"
                className="form-control form-control-sm"
              >
                <option value="">Select Credit Officer</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-group">
          <button className="btn btn-outline-secondary btn-sm">
            <small>
              <MdFileOpen size={20} style={{ marginRight: "5px" }} />
              Preview Repayment Schedule
            </small>
          </button>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
